import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell, AreaChart, Area } from "recharts";

const TEAL = "#1D9E75";
const NAVY = "#1a2e4a";
const LIGHT_TEAL = "#E8F6F1";
const LIGHT_NAVY = "#E8EDF3";
const GRAY = "#64748B";
const ORANGE = "#F59E0B";

const volA1 = [
  { mes: "M1", shellon: 0, va: 44000, fclS: 0, fclVA: 1 },
  { mes: "M2", shellon: 0, va: 44000, fclS: 0, fclVA: 1 },
  { mes: "M3", shellon: 0, va: 88000, fclS: 0, fclVA: 2 },
  { mes: "M4", shellon: 50000, va: 88000, fclS: 1, fclVA: 2 },
  { mes: "M5", shellon: 50000, va: 88000, fclS: 1, fclVA: 2 },
  { mes: "M6", shellon: 100000, va: 88000, fclS: 2, fclVA: 2 },
  { mes: "M7", shellon: 100000, va: 132000, fclS: 2, fclVA: 3 },
  { mes: "M8", shellon: 100000, va: 132000, fclS: 2, fclVA: 3 },
  { mes: "M9", shellon: 100000, va: 132000, fclS: 2, fclVA: 3 },
  { mes: "M10", shellon: 100000, va: 132000, fclS: 2, fclVA: 3 },
  { mes: "M11", shellon: 100000, va: 132000, fclS: 2, fclVA: 3 },
  { mes: "M12", shellon: 100000, va: 132000, fclS: 2, fclVA: 3 },
];

const volA2 = Array.from({length:12}, (_,i) => ({
  mes: "M"+(i+1), shellon: 100000, va: 132000, fclS: 2, fclVA: 3
}));

const fclAcum = [];
let ac1 = 0, ac2 = 0;
volA1.forEach((m, i) => {
  ac1 += m.fclS + m.fclVA;
  ac2 += volA2[i].fclS + volA2[i].fclVA;
  fclAcum.push({ mes: m.mes, a1: ac1, a2: ac2 });
});

const totalShA1 = 800000, totalVAa1 = 1232000;
const totalShA2 = 1200000, totalVAa2 = 1584000;
const totalLbA1 = totalShA1 + totalVAa1;
const totalLbA2 = totalShA2 + totalVAa2;
const fclShA1 = 16, fclVAa1 = 28, fclShA2 = 24, fclVAa2 = 36;
const totalFclA1 = fclShA1 + fclVAa1;
const totalFclA2 = fclShA2 + fclVAa2;
const grandTotalLb = totalLbA1 + totalLbA2;
const grandTotalFcl = totalFclA1 + totalFclA2;

const comparativoAnual = [
  { name: "Shellon", a1Lb: totalShA1, a2Lb: totalShA2, a1Fcl: fclShA1, a2Fcl: fclShA2 },
  { name: "V.Agregado", a1Lb: totalVAa1, a2Lb: totalVAa2, a1Fcl: fclVAa1, a2Fcl: fclVAa2 },
];

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload) return null;
  return (
    <div style={{ background: NAVY, padding: "10px 14px", borderRadius: 8, boxShadow: "0 4px 12px rgba(0,0,0,0.15)" }}>
      <div style={{ color: "#94A3B8", fontSize: 11, marginBottom: 4 }}>{label}</div>
      {payload.map((p, i) => (
        <div key={i} style={{ color: p.color || "#fff", fontSize: 13, fontWeight: 600 }}>
          {p.name}: {typeof p.value === "number" ? p.value.toLocaleString() : p.value}
        </div>
      ))}
    </div>
  );
};

export default function DashboardOperativo() {
  const card = { background: "#fff", borderRadius: 10, padding: "18px 20px", boxShadow: "0 1px 4px rgba(0,0,0,0.04)", border: "1px solid #E8ECF0" };
  const stitle = { fontSize: 14, fontWeight: 700, color: NAVY, marginBottom: 14, letterSpacing: "0.5px", textTransform: "uppercase", borderBottom: "2px solid " + TEAL, paddingBottom: 8, display: "inline-block" };

  return (
    <div style={{ fontFamily: "'Inter', system-ui, sans-serif", background: "#F7F9FB", minHeight: "100vh" }}>
      {/* Header */}
      <div style={{ background: "linear-gradient(135deg, " + NAVY + ", #2a4a6a)", padding: "24px 36px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontSize: 11, color: TEAL, fontWeight: 600, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Dashboard Operativo</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: "#fff" }}>Linea de Camaron — Produccion</div>
          <div style={{ fontSize: 12, color: "#94A3B8", marginTop: 4 }}>Fuente: Proyecto Linea de Camaron rev1.xlsx — Hoja ERI (2)</div>
        </div>
        <div style={{ display: "flex", gap: 20, textAlign: "center" }}>
          <div><div style={{ fontSize: 28, fontWeight: 800, color: TEAL }}>{totalFclA1}</div><div style={{ fontSize: 10, color: "#94A3B8" }}>FCL Ano 1</div></div>
          <div><div style={{ fontSize: 28, fontWeight: 800, color: ORANGE }}>{totalFclA2}</div><div style={{ fontSize: 10, color: "#94A3B8" }}>FCL Ano 2</div></div>
          <div style={{borderLeft:"1px solid rgba(255,255,255,0.2)",paddingLeft:20}}><div style={{ fontSize: 28, fontWeight: 800, color: "#fff" }}>{grandTotalFcl}</div><div style={{ fontSize: 10, color: "#94A3B8" }}>FCL Total</div></div>
        </div>
      </div>

      <div style={{ padding: "24px 36px", maxWidth: 1300, margin: "0 auto" }}>

        {/* TOTALES ANUALES - Resumen ejecutivo */}
        <div style={{ marginBottom: 28 }}>
          <div style={{...card, background: "linear-gradient(135deg, #f0fdf4, #e8f6f1)", border: "2px solid " + TEAL + "30" }}>
            <div style={stitle}>Resumen de totales anuales</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 0, marginTop: 8 }}>
              {/* Headers */}
              <div style={{ padding: "10px 12px", background: NAVY, color: "#fff", fontWeight: 700, fontSize: 12, borderRadius: "8px 0 0 0" }}>Producto</div>
              <div style={{ padding: "10px 12px", background: NAVY, color: "#fff", fontWeight: 700, fontSize: 12, textAlign: "center" }}>Libras Ano 1</div>
              <div style={{ padding: "10px 12px", background: NAVY, color: "#fff", fontWeight: 700, fontSize: 12, textAlign: "center" }}>FCL Ano 1</div>
              <div style={{ padding: "10px 12px", background: NAVY, color: "#fff", fontWeight: 700, fontSize: 12, textAlign: "center" }}>Libras Ano 2</div>
              <div style={{ padding: "10px 12px", background: NAVY, color: "#fff", fontWeight: 700, fontSize: 12, textAlign: "center", borderRadius: "0 8px 0 0" }}>FCL Ano 2</div>
              {/* Shellon */}
              <div style={{ padding: "14px 12px", background: LIGHT_TEAL, fontWeight: 700, fontSize: 14, color: TEAL, borderBottom: "1px solid #d1e7dd" }}>Shellon</div>
              <div style={{ padding: "14px 12px", background: LIGHT_TEAL, textAlign: "center", fontWeight: 800, fontSize: 16, color: TEAL, borderBottom: "1px solid #d1e7dd" }}>{totalShA1.toLocaleString()}</div>
              <div style={{ padding: "14px 12px", background: LIGHT_TEAL, textAlign: "center", fontWeight: 800, fontSize: 16, color: TEAL, borderBottom: "1px solid #d1e7dd" }}>{fclShA1}</div>
              <div style={{ padding: "14px 12px", background: LIGHT_TEAL, textAlign: "center", fontWeight: 800, fontSize: 16, color: TEAL, borderBottom: "1px solid #d1e7dd" }}>{totalShA2.toLocaleString()}</div>
              <div style={{ padding: "14px 12px", background: LIGHT_TEAL, textAlign: "center", fontWeight: 800, fontSize: 16, color: TEAL, borderBottom: "1px solid #d1e7dd" }}>{fclShA2}</div>
              {/* VA */}
              <div style={{ padding: "14px 12px", background: LIGHT_NAVY, fontWeight: 700, fontSize: 14, color: NAVY, borderBottom: "1px solid #cdd5e0" }}>Valor Agregado</div>
              <div style={{ padding: "14px 12px", background: LIGHT_NAVY, textAlign: "center", fontWeight: 800, fontSize: 16, color: NAVY, borderBottom: "1px solid #cdd5e0" }}>{totalVAa1.toLocaleString()}</div>
              <div style={{ padding: "14px 12px", background: LIGHT_NAVY, textAlign: "center", fontWeight: 800, fontSize: 16, color: NAVY, borderBottom: "1px solid #cdd5e0" }}>{fclVAa1}</div>
              <div style={{ padding: "14px 12px", background: LIGHT_NAVY, textAlign: "center", fontWeight: 800, fontSize: 16, color: NAVY, borderBottom: "1px solid #cdd5e0" }}>{totalVAa2.toLocaleString()}</div>
              <div style={{ padding: "14px 12px", background: LIGHT_NAVY, textAlign: "center", fontWeight: 800, fontSize: 16, color: NAVY, borderBottom: "1px solid #cdd5e0" }}>{fclVAa2}</div>
              {/* TOTALES */}
              <div style={{ padding: "14px 12px", background: NAVY, fontWeight: 800, fontSize: 14, color: "#fff", borderRadius: "0 0 0 8px" }}>TOTAL</div>
              <div style={{ padding: "14px 12px", background: NAVY, textAlign: "center", fontWeight: 800, fontSize: 18, color: TEAL }}>{totalLbA1.toLocaleString()}</div>
              <div style={{ padding: "14px 12px", background: NAVY, textAlign: "center", fontWeight: 800, fontSize: 18, color: TEAL }}>{totalFclA1}</div>
              <div style={{ padding: "14px 12px", background: NAVY, textAlign: "center", fontWeight: 800, fontSize: 18, color: ORANGE }}>{totalLbA2.toLocaleString()}</div>
              <div style={{ padding: "14px 12px", background: NAVY, textAlign: "center", fontWeight: 800, fontSize: 18, color: ORANGE, borderRadius: "0 0 8px 0" }}>{totalFclA2}</div>
            </div>

            {/* Gran total */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16, marginTop: 20 }}>
              <div style={{ background: "white", borderRadius: 10, padding: "16px 20px", textAlign: "center", border: "2px solid " + TEAL }}>
                <div style={{ fontSize: 11, color: GRAY, fontWeight: 600, marginBottom: 4 }}>Total libras 2 anos</div>
                <div style={{ fontSize: 28, fontWeight: 800, color: TEAL }}>{grandTotalLb.toLocaleString()}</div>
                <div style={{ fontSize: 11, color: GRAY }}>lb</div>
              </div>
              <div style={{ background: "white", borderRadius: 10, padding: "16px 20px", textAlign: "center", border: "2px solid " + NAVY }}>
                <div style={{ fontSize: 11, color: GRAY, fontWeight: 600, marginBottom: 4 }}>Total FCL 2 anos</div>
                <div style={{ fontSize: 28, fontWeight: 800, color: NAVY }}>{grandTotalFcl}</div>
                <div style={{ fontSize: 11, color: GRAY }}>contenedores</div>
              </div>
              <div style={{ background: "white", borderRadius: 10, padding: "16px 20px", textAlign: "center", border: "2px solid " + ORANGE }}>
                <div style={{ fontSize: 11, color: GRAY, fontWeight: 600, marginBottom: 4 }}>Crecimiento Ano 1 a Ano 2</div>
                <div style={{ fontSize: 28, fontWeight: 800, color: ORANGE }}>+{Math.round((totalLbA2/totalLbA1-1)*100)}%</div>
                <div style={{ fontSize: 11, color: GRAY }}>en volumen</div>
              </div>
            </div>
          </div>
        </div>

        {/* KPIs por producto */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 12, marginBottom: 28 }}>
          {[
            ["Shellon Ano 1", totalShA1.toLocaleString(), "lb", TEAL, LIGHT_TEAL],
            ["V.Agregado Ano 1", totalVAa1.toLocaleString(), "lb", NAVY, LIGHT_NAVY],
            ["Total Ano 1", totalLbA1.toLocaleString(), "lb", TEAL, LIGHT_TEAL],
            ["Shellon Ano 2", totalShA2.toLocaleString(), "lb", TEAL, LIGHT_TEAL],
            ["V.Agregado Ano 2", totalVAa2.toLocaleString(), "lb", NAVY, LIGHT_NAVY],
            ["Total Ano 2", totalLbA2.toLocaleString(), "lb", ORANGE, LIGHT_NAVY],
          ].map(([l, v, s, c, bg], i) => (
            <div key={i} style={{ background: bg, borderRadius: 10, padding: "14px", textAlign: "center" }}>
              <div style={{ fontSize: 10, color: GRAY, fontWeight: 600, marginBottom: 6 }}>{l}</div>
              <div style={{ fontSize: 20, fontWeight: 800, color: c }}>{v}</div>
              <div style={{ fontSize: 10, color: GRAY, marginTop: 4 }}>{s}</div>
            </div>
          ))}
        </div>

        {/* FCL grid mensual Ano 1 */}
        <div style={{ marginBottom: 8 }}><div style={{ fontSize: 12, fontWeight: 700, color: NAVY, marginBottom: 6 }}>FCL Y LIBRAS MENSUALES — ANO 1</div></div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(12, 1fr)", gap: 6, marginBottom: 28 }}>
          {volA1.map((m, i) => (
            <div key={i} style={{ background: "#fff", borderRadius: 8, padding: "10px 4px", textAlign: "center", border: "1px solid #E8ECF0" }}>
              <div style={{ fontSize: 10, color: GRAY, fontWeight: 600, marginBottom: 4 }}>{m.mes}</div>
              <div style={{ fontSize: 15, fontWeight: 800, color: TEAL }}>{m.fclS}</div>
              <div style={{ fontSize: 9, color: GRAY }}>Shellon</div>
              <div style={{ fontSize: 15, fontWeight: 800, color: NAVY, marginTop: 3 }}>{m.fclVA}</div>
              <div style={{ fontSize: 9, color: GRAY }}>V.Agreg</div>
              <div style={{ marginTop: 4, fontSize: 9, fontWeight: 700, color: ORANGE }}>{((m.shellon + m.va) / 1000).toFixed(0)}K lb</div>
            </div>
          ))}
        </div>

        {/* Graficas Ano 1 y 2 */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 28 }}>
          <div style={card}>
            <div style={stitle}>Libras por mes — Ano 1</div>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={volA1} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E8ECF0" />
                <XAxis dataKey="mes" tick={{ fontSize: 10, fill: GRAY }} />
                <YAxis tick={{ fontSize: 10, fill: GRAY }} tickFormatter={v => (v/1000)+"K"} />
                <Tooltip content={<CustomTooltip />} />
                <Legend wrapperStyle={{ fontSize: 11 }} />
                <Bar dataKey="shellon" name="Shellon" fill={TEAL} radius={[3,3,0,0]} stackId="a" />
                <Bar dataKey="va" name="V.Agregado" fill={NAVY} radius={[3,3,0,0]} stackId="a" />
              </BarChart>
            </ResponsiveContainer>
            <div style={{ textAlign: "right", fontSize: 11, color: GRAY, marginTop: 4 }}>
              Total: <b style={{color:TEAL}}>{totalLbA1.toLocaleString()} lb</b> · <b style={{color:NAVY}}>{totalFclA1} FCL</b>
            </div>
          </div>
          <div style={card}>
            <div style={stitle}>Libras por mes — Ano 2</div>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={volA2} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E8ECF0" />
                <XAxis dataKey="mes" tick={{ fontSize: 10, fill: GRAY }} />
                <YAxis tick={{ fontSize: 10, fill: GRAY }} tickFormatter={v => (v/1000)+"K"} />
                <Tooltip content={<CustomTooltip />} />
                <Legend wrapperStyle={{ fontSize: 11 }} />
                <Bar dataKey="shellon" name="Shellon" fill={TEAL} radius={[3,3,0,0]} stackId="a" />
                <Bar dataKey="va" name="V.Agregado" fill={NAVY} radius={[3,3,0,0]} stackId="a" />
              </BarChart>
            </ResponsiveContainer>
            <div style={{ textAlign: "right", fontSize: 11, color: GRAY, marginTop: 4 }}>
              Total: <b style={{color:ORANGE}}>{totalLbA2.toLocaleString()} lb</b> · <b style={{color:NAVY}}>{totalFclA2} FCL</b>
            </div>
          </div>
        </div>

        {/* Comparativo barras agrupadas */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 28 }}>
          <div style={card}>
            <div style={stitle}>Comparativo libras por producto</div>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={comparativoAnual} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E8ECF0" />
                <XAxis dataKey="name" tick={{ fontSize: 11, fill: GRAY }} />
                <YAxis tick={{ fontSize: 10, fill: GRAY }} tickFormatter={v => (v/1000000).toFixed(1)+"M"} />
                <Tooltip content={<CustomTooltip />} />
                <Legend wrapperStyle={{ fontSize: 11 }} />
                <Bar dataKey="a1Lb" name="Ano 1 (lb)" fill={TEAL} radius={[4,4,0,0]} />
                <Bar dataKey="a2Lb" name="Ano 2 (lb)" fill={ORANGE} radius={[4,4,0,0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div style={card}>
            <div style={stitle}>Comparativo FCL por producto</div>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={comparativoAnual} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E8ECF0" />
                <XAxis dataKey="name" tick={{ fontSize: 11, fill: GRAY }} />
                <YAxis tick={{ fontSize: 10, fill: GRAY }} />
                <Tooltip content={<CustomTooltip />} />
                <Legend wrapperStyle={{ fontSize: 11 }} />
                <Bar dataKey="a1Fcl" name="Ano 1 (FCL)" fill={TEAL} radius={[4,4,0,0]} />
                <Bar dataKey="a2Fcl" name="Ano 2 (FCL)" fill={ORANGE} radius={[4,4,0,0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* FCL Acumulado + Mix */}
        <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 20, marginBottom: 28 }}>
          <div style={card}>
            <div style={stitle}>FCL acumulados</div>
            <ResponsiveContainer width="100%" height={220}>
              <AreaChart data={fclAcum} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E8ECF0" />
                <XAxis dataKey="mes" tick={{ fontSize: 10, fill: GRAY }} />
                <YAxis tick={{ fontSize: 10, fill: GRAY }} />
                <Tooltip content={<CustomTooltip />} />
                <Legend wrapperStyle={{ fontSize: 11 }} />
                <Area type="monotone" dataKey="a1" name="Ano 1" stroke={TEAL} fill={TEAL} fillOpacity={0.15} strokeWidth={2} />
                <Area type="monotone" dataKey="a2" name="Ano 2" stroke={ORANGE} fill={ORANGE} fillOpacity={0.15} strokeWidth={2} />
              </AreaChart>
            </ResponsiveContainer>
          </div>
          <div style={card}>
            <div style={stitle}>Mix mensual (plena capacidad)</div>
            <ResponsiveContainer width="100%" height={180}>
              <PieChart>
                <Pie data={[{name:"Shellon",value:100000},{name:"V.Agregado",value:132000}]} cx="50%" cy="50%" innerRadius={45} outerRadius={75} dataKey="value" label={({name,percent})=>name+" "+(percent*100).toFixed(0)+"%"}>
                  <Cell fill={TEAL} />
                  <Cell fill={NAVY} />
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
            <div style={{ textAlign: "center", fontSize: 12, color: GRAY }}>232,000 lb/mes · 5 FCL/mes</div>
          </div>
        </div>

        {/* Productos detalle */}
        <div style={{ marginBottom: 28 }}>
          <div style={card}>
            <div style={stitle}>Detalle por producto</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginTop: 8 }}>
              {[
                { name: "Shellon", lb: "100,000 lb/mes", fclMes: 2, fA1: fclShA1, fA2: fclShA2, tA1: totalShA1.toLocaleString(), tA2: totalShA2.toLocaleString(), inicio: "Mes 4", c: TEAL, bg: LIGHT_TEAL },
                { name: "Valor Agregado", lb: "132,000 lb/mes", fclMes: 3, fA1: fclVAa1, fA2: fclVAa2, tA1: totalVAa1.toLocaleString(), tA2: totalVAa2.toLocaleString(), inicio: "Mes 1", c: NAVY, bg: LIGHT_NAVY },
              ].map((p, i) => (
                <div key={i} style={{ background: p.bg, borderRadius: 10, padding: "20px 24px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
                    <div style={{ fontWeight: 800, fontSize: 17, color: p.c }}>{p.name}</div>
                    <div style={{ fontWeight: 700, fontSize: 13, color: GRAY }}>{p.lb}</div>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 10, marginBottom: 10 }}>
                    {[["Inicio", p.inicio], ["FCL/mes", p.fclMes], ["FCL Ano 1", p.fA1], ["FCL Ano 2", p.fA2]].map(([l,v],j)=>(
                      <div key={j}><div style={{fontSize:10,color:GRAY}}>{l}</div><div style={{fontWeight:700,fontSize:15,color:p.c}}>{v}</div></div>
                    ))}
                  </div>
                  <div style={{ borderTop: "1px solid "+p.c+"20", paddingTop: 10, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                    <div><div style={{fontSize:10,color:GRAY}}>Total Ano 1</div><div style={{fontWeight:700,fontSize:13,color:p.c}}>{p.tA1} lb</div></div>
                    <div><div style={{fontSize:10,color:GRAY}}>Total Ano 2</div><div style={{fontWeight:700,fontSize:13,color:p.c}}>{p.tA2} lb</div></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={{ textAlign: "center", padding: "12px 0", fontSize: 11, color: "#94A3B8" }}>
          Dashboard Operativo — Linea de Camaron · Datos reales ERI (2) · Confidencial
        </div>
      </div>
    </div>
  );
}
